import styled from "styled-components"
import { device } from "breakpoints"
import { MainColumn } from "UI/MainColumn"
import { Text } from "UI"

export const Container = styled(MainColumn)`
  margin: 40px auto;

  display: flex;
  flex-direction: column;
  max-width: 1160px !important;

  @media (min-width: 768px) {
    margin: 50px auto;
    flex-direction: row;
  }

  @media ${device.desktop} {
    margin: 60px auto;
  }
`

export const Featured = styled.div`
  position: relative;
  overflow: hidden;
  background: white;

  @media ${device.tablet} {
    width: 50%;
  }
  .icon {
    position: absolute;
    z-index: 3;

    :nth-of-type(1) {
      top: 20px;
      left: -20px;

      @media ${device.desktop} {
        top: 30px;
        left: -30px;
      }

      @media ${device.large} {
        top: 30px;
        left: -40px;
      }
    }

    :nth-of-type(2) {
      top: 104px;
      left: 30px;

      @media ${device.desktop} {
        top: 150px;
        left: 40px;
      }

      @media ${device.large} {
        top: 180px;
        left: 50px;
      }
    }
  }
`

export const FeaturedPhoto = styled.div`
  display: block !important;
  position: relative;
  padding-top: 70%;
  width: 100%;
  border-radius: 5px 5px 0 0;
  overflow: hidden;

  @media ${device.tablet} {
    padding-top: 80%;
    border-radius: 5px 0 0 5px;
    padding-top: 100%;
    height: 100%;
  }

  .avenueImg__imgWrapper {
    position: absolute !important;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    object-fit: cover;

    @media ${device.tablet} {
      img {
        height: 100%;
        object-fit: cover;
      }
    }
  }
`

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 0 0 10px 10px;
  background: ${(props) => props.theme.primaryColor};
  padding: 45px 30px 25px 30px;
  position: relative;
  color: white;
  overflow: hidden;

  span {
    font-weight: 700;
    font-size: 12px;
    margin-top: 15px;
    display: block;
    @media ${device.tablet} {
      font-size: 14px;
      margin-top: 18px;
    }
  }

  @media ${device.tablet} {
    padding: 45px 45px 45px 45px;

    border-radius: 0 5px 5px 0;
    width: 50%;
    margin-top: 0;
  }

  @media ${device.desktop} {
    border-radius: 0 5px 5px 0;
    padding: 55px 60px 55px 60px;
  }
  @media ${device.large} {
    padding: 64px 70px 64px 70px;
  }

  .icon.quotation-marks {
    position: absolute;
    top: -4px;
    left: 30px;
    z-index: 3;

    @media ${device.tablet} {
      left: -10px;
      top: 20px;
    }

    @media ${device.desktop} {
      left: -12px;
      top: 16px;
    }

    @media ${device.large} {
      left: -17px;
      top: 37px;
    }
  }
`

export const CustomTestimonialText = styled(Text)`
  color: inherit;
  font-size: 16px;
  line-height: 150%;
  font-weight: 300;
  @media ${device.tablet} {
    font-size: 18px;
  }

  @media ${device.desktop} {
    font-size: 22px;
  }
  @media ${device.large} {
    font-size: 24px;
  }
`
